import { Box, Typography } from "@mui/material"
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"
import React, { useState } from "react"

import { Button } from "@/components/common/Button"
import type { Contact } from "@/graphql/codegen/graphql"
import ContactCard from "@/screens/Companies/edit/components/locations/components/ContactCard"

interface AllLocationContactsProps {
  contactList: Contact[]
  locationId: string
  onRefresh?: () => void
}

const AllLocationContacts = ({ contactList, locationId, onRefresh }: AllLocationContactsProps): ReactElement | null => {
  const [isAllContactsVisible, setIsAllContactsVisible] = useState(false)

  const handleToggleContactsVisibility = () => {
    setIsAllContactsVisible((prev) => !prev)
  }

  const numberOfContacts = contactList.length

  const [menuState, setMenuState] = useState<{
    contactId: string | null
    anchorEl: HTMLElement | null
  }>({ contactId: null, anchorEl: null })

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, contactId: string) => {
    setMenuState({ contactId, anchorEl: event.currentTarget })
  }

  const handleMenuClose = () => {
    setMenuState({ contactId: null, anchorEl: null })
  }

  if (!numberOfContacts) {
    return null
  }

  return !isAllContactsVisible ? (
    <Box className='flex justify-end px-4 pb-1 pt-0'>
      <Button
        variant='primary'
        appearance='text'
        aria-label='view contacts'
        className='size-fit p-4'
        onClick={handleToggleContactsVisibility}
        startIcon={<VisibilityOutlined />}
      >
        All Contacts [{numberOfContacts}]
      </Button>
    </Box>
  ) : (
    <Box className='flex flex-col items-start p-4'>
      <Box className='flex items-center py-4'>
        <Typography variant='body2' className='text-base text-primary'>
          Other Contacts
        </Typography>
      </Box>
      {contactList.map((contact) => (
        <ContactCard
          contact={contact}
          handleMenuOpen={(e) => handleMenuOpen(e, contact?.contactId as string)}
          handleMenuClose={handleMenuClose}
          anchorEl={menuState.contactId === contact?.contactId ? menuState.anchorEl : null}
          className='w-full'
          key={contact.contactId}
          locationId={locationId}
          onRemoveSuccess={onRefresh}
        />
      ))}
      <Box className='flex justify-end self-end p-4'>
        <Button
          variant='primary'
          appearance='text'
          aria-label='view contacts'
          className='size-fit p-4'
          onClick={handleToggleContactsVisibility}
          startIcon={<VisibilityOffOutlined />}
        >
          Hide contacts
        </Button>
      </Box>
    </Box>
  )
}

export default AllLocationContacts
